var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDotMenu = function SvgDotMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M3.65 10.03c-.98.16-1.7 1.1-1.65 2.09.13 2.02 2.87 2.58 3.79.78a2.01 2.01 0 0 0-2.14-2.87m7.84.04a2 2 0 1 0 1 3.86 2 2 0 0 0-1-3.86m8 0a2 2 0 1 0 2.3 1.03 2.04 2.04 0 0 0-2.3-1.03",
    clipRule: "evenodd"
  })));
};
export { SvgDotMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjY1IDEwLjAzYy0uOTguMTYtMS43IDEuMS0xLjY1IDIuMDkuMTMgMi4wMiAyLjg3IDIuNTggMy43OS43OGEyLjAxIDIuMDEgMCAwIDAtMi4xNC0yLjg3Wm03Ljg0LjA0YTIgMiAwIDEgMCAxIDMuODYgMiAyIDAgMCAwLTEtMy44NlptOCAwYTIgMiAwIDEgMCAyLjMgMS4wMyAyLjA0IDIuMDQgMCAwIDAtMi4zLTEuMDNaIiBmaWxsPSIjMDAwIi8+PC9zdmc+Cg==";